import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import CustomRescuersFormPage from "../components/CustomRescuersFormPage";

const CustomRescuersForm = () => {
  return (
    <div>
      <MasterLayout>
        <CustomRescuersFormPage />
      </MasterLayout>
    </div>
  );
};

export default CustomRescuersForm;
